var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('div',{staticClass:"font"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"btn",on:{"click":_vm.jump}},[_vm._v(_vm._s(_vm.btnDesc))])])
}
var staticRenderFns = []

export { render, staticRenderFns }